import melePlayer from 'melePlayer'

// SK date format: DD.MM.YYYY instead of ISO YYYY-MM-DD
const _originalUpdateStateLabel = melePlayer.prototype.updateStateLabel
melePlayer.prototype.updateStateLabel = function() {
  _originalUpdateStateLabel.call(this)
  if(this.elState && this.state === 'playing' && !this.live) {
    const usec = this.ets > 0 ? this.ets : this.start
    if(usec > 0) {
      const str_date = _.usec2ld(usec).split('-').reverse().join('.')
      const str_time = _.usec2lt(usec)
      this.elState.label = `<playdate>${str_date}</playdate><playtime>${str_time}</playtime>`
    }
  }
}
